export default __webpack_public_path__ + "static/strona-f99ae0d97dabbd7f63c07f9e83a827e7.jpeg";